import { Moon, Sun } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useTheme } from '@/hooks/use-theme'
import { useUserPreference } from '@/hooks/use-user-preference'

export function ThemeToggle() {
  const { setTheme } = useTheme()
  const { upsertUserPreference } = useUserPreference()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button id='theme-toggle-trigger' variant='outline' size='icon'>
          <Sun className='h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0' />
          <Moon className='absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
          <span className='sr-only'>Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem
          onClick={async () => {
            setTheme('light')
            await upsertUserPreference('theme', 'light', true)
          }}
        >
          <Sun className='h-[1.2rem] w-[1.2rem]' />
          Light
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={async () => {
            setTheme('dark')
            await upsertUserPreference('theme', 'dark', true)
          }}
        >
          <Moon className='h-[1rem] w-[1rem]' />
          Dark
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
